import React from 'react';
import { useMutation } from '@apollo/client';
import LeaveSessionComponent from './component';
import logger from '/imports/startup/client/logger';
import { USER_LEAVE_MEETING } from '/imports/ui/core/graphql/mutations/userMutations';
import Session from '/imports/ui/services/storage/in-memory';
import Auth from '/imports/ui/services/auth';
import { logoutUser } from '../app/service';

const LeaveSessionContainer = (props) => {
  const [userLeaveMeeting] = useMutation(USER_LEAVE_MEETING);
  const { setIsOpen, courseDetails } = props;

  const leaveSession = () => {
    logger.warn({
      logCode: 'user_leaving_session',
      extraInfo: { logType: 'user_action' },
    }, 'this user clicked on LeaveSession and confirmed, leaving the meeting');

       userLeaveMeeting();

    // if (!Auth?._meetingID && !Auth?._externUserID) return;
    
    // const apiPayload = {
    //   internalMeetingID: Auth?._meetingID,
    //   externalUserID: Auth?._externUserID,
    //    courseSessionId: courseDetails?.course?.courseDetail?.courseSessionId,
    //   isPrepareLesson: courseDetails?.course?.courseDetail?.isPrepareLesson
    // }

    // // FETCH COURSE DETAILS FROM API
    // logoutUser(apiPayload).then(() => {
    // })
    //   .catch((error) => {
    //     console.error('ERROR IN LOGOUT USER', error?.message)
    //   }).finally(() => {
    //     userLeaveMeeting();
    //      setIsOpen(false);
    //     Session.setItem('codeError', '680');
    //   });

   
  };

  return (
    <LeaveSessionComponent
      leaveSession={leaveSession}
      {...props}
    />
  );
};

export default LeaveSessionContainer; 